export enum SearchFilters {
    LISTS = 'lists',
}
